module.exports = __webpack_public_path__ + "img/fail.401090d9.png";